import axios from 'axios';

export const axiosConnect = axios.create({
    baseURL: process.env.CONNECT_URL,
    headers: {
        'Authorization': `Bearer ${process.env.CONNECT_TOKEN}`
    }
});

export const axiosFaturas = axios.create({
    baseURL: process.env.CONNECT_APIM_FATURAS,
    headers: {
        'Authorization': `Bearer ${process.env.CONNECT_TOKEN}`,
        'ocp-apim-subscription-key': process.env.CONNECT_APIM_SUBSCRIPTION_KEY_FATURAS,
        'product': 'connect'
    }
});

const emailCheckerBaseUrl = process.env.VUE_APP_URL_API
    ? process.env.VUE_APP_URL_API.replace(/\/api\/?$/, '/v1/origo/')
    : '';

export const axiosEmailChecker = axios.create({
    baseURL: emailCheckerBaseUrl
});



// WEBPACK FOOTER //
// ./src/plugins/axiosConnect.js